/* tslint:disable */
/* eslint-disable */
/**
 * Telematics backend API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: mojmir.studenovsky@eurowag.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * An enumeration.
 * @export
 * @enum {string}
 */
export enum NegotiableAttributes {
    Price = 'price'
}

export function NegotiableAttributesFromJSON(json: any): NegotiableAttributes {
    return NegotiableAttributesFromJSONTyped(json, false);
}

export function NegotiableAttributesFromJSONTyped(json: any, ignoreDiscriminator: boolean): NegotiableAttributes {
    return json as NegotiableAttributes;
}

export function NegotiableAttributesToJSON(value?: NegotiableAttributes | null): any {
    return value as any;
}

